import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable()
export class SupplyDemandGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let supplyDemandAccess = localStorage.getItem('supply_demand_access');
    if (supplyDemandAccess !== undefined && supplyDemandAccess !== null && supplyDemandAccess !== '' && supplyDemandAccess =='true') {
      return of(true);
    }
    else {
      this.router.navigate(['']);
      return of(false);
    }
  }
}